var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[_c('p',[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Toaster Artist"),_c('br')])])}
var staticRenderFns = []

export { render, staticRenderFns }